import { connect } from "react-redux";
import CardCampaignStatusComponent from "../components/CardCampaignStatusComponent";
import DisplayActions from "../redux/DisplayRedux";
import UserAccountActions from "../redux/UserAccountRedux";

const mapStateToProps = ({ display, userAccount }) => ({
  user: userAccount.user,
  currentCampaign: display.currentCampaign,
  customContents: display.customContents,
  isPaymentStatusApproved: display.isPaymentStatusApproved,
  isCampaignPaused: display.isCampaignPaused,
  editCampaignActive: display.editCampaignActive,
  allDisplaysAreOwn: display.allDisplaysAreOwn
});

const mapStateToDispatch = dispatch => ({
  setIsCampaignPaused: isCampaignPaused => dispatch(DisplayActions.setIsCampaignPause(isCampaignPaused)),
  setActive: isCampaignPaused => dispatch(DisplayActions.updateFieldInCustomContents(null, isCampaignPaused ? 0 : 1, "active", "multiple"))
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(CardCampaignStatusComponent); 